<template>
  <div>
    <el-table v-loading="loading" :data="bloodSugarList" @sort-change="handleSortChange">
      <el-table-column align="center" label="用户姓名" prop="userName" />
      <el-table-column align="center" label="血糖值" prop="value" />
      <el-table-column label="记录日期" align="center" prop="day" width="180" sortable="custom"  :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.day, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"/>
  </div>
</template>

<script>


import {listUserBloodSugar} from "@/api/biz/UserBloodSugar";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: true,
      // 总条数
      total: 0,
      // 用户体重记录表格数据
      bloodSugarList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    /** 查询用户体重记录列表 */
    getList() {
      this.queryParams.userId = this.user.id;
      this.loading = true;
      listUserBloodSugar(this.queryParams).then(response => {
        this.bloodSugarList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>
